import Big from 'big.js';
import { formatAmount } from '@nbx/frontend-helpers/format';
import { calculateValueForAsset } from '@nbx/providers';

Big.RM = 0;

export function formatAndTruncateBalance(balance, assets, asset) {
  return formatAmount(balance, assets[asset.toUpperCase()]?.displayPrecision ?? 2);
}

export const isNaNish = value => {
  return value === null || value === undefined || isNaN(value);
};

export const convertToAsset = (baseAsset, targetAsset, tickers, quantity) => {
  const processedTickers = tickers.map(ticker => {
    return {
      ...ticker.data,
      bigPrice:
        !ticker.error && !isNaNish(ticker.data.price) && ticker.data?.price !== undefined
          ? Big(ticker.data.price)
          : null
    };
  });
  return calculateValueForAsset(
    baseAsset.toUpperCase(),
    targetAsset.toUpperCase(),
    processedTickers,
    Big(quantity)
  );
};
